import React from "react";
import { useTranslation } from "react-i18next";


const HeroSection = () => {
  const { t,i18n } = useTranslation("certificates"); // Hook to use translations
  const isRussian = i18n.language === "ru"; // Check if the language is Russian


  return (
    <div className="relative h-[654px] md:h-[592px]">
      <img
        src="/assets/servicesbg.svg"
        className="w-full h-full object-cover"
        alt="background animation"
      />
      <div className="absolute inset-0 bg-[#00000099]"></div>
      <img
        src="/assets/ellipse.svg"
        className="absolute bottom-64 left-1/2 transform -translate-x-1/2 translate-y-1/2"
        alt="ellipse decoration"
      />
      <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-2 md:px-4 mb-16">
        {/* Welcome Text */}
        <div className="title-small text-[#05897E] py-2 px-4 rounded-full mb-4 border border-[#FFFFFF33]">
        {t("certificates_section_title")}
        </div>
       
       <div className="max-w-[940px]">
         {/* Main Heading */}
         <h1 className={`web-heading-main mb-4 ${isRussian ? 'lang-ru-web-heading-main' : ''}`}>

          {t("distributor_certificates_title")}</h1>
        {/* Description */}
        <p className="text-color body-large-30 mb-6 md:text-xl max-w-5xl">
        {t("distributor_certificates_description")}
        </p>
       </div>
      </div>
    </div>
  );
};

export default HeroSection;
